import Notfound from "pages/public/Notfound"
import { RouteObject } from "react-router-dom"

const NotfoundRoute: RouteObject = {
      path: "*",
      element: <Notfound/>,
    }
export default NotfoundRoute
